const INDUSTRIES = ["Technology", "Web3", "Finance", "Consumer", "Events", "Hospitality", "Healthcare"];

const Group = () => (
  <div className="flex items-center">
    {INDUSTRIES.map((name) => (
      <span key={name} className="flex items-center whitespace-nowrap">
        <span className="px-6 font-display text-2xl font-bold uppercase tracking-tight text-ink md:px-10 md:text-4xl">
          {name}
        </span>
        <span className="text-sm text-ember" aria-hidden="true">
          ✳
        </span>
      </span>
    ))}
  </div>
);

export const IndustriesStrip = () => (
  <section className="py-24 md:py-40" data-testid="industries-section">
    <div className="container-ak">
      <p className="mb-10 max-w-[560px] text-base leading-relaxed text-ink2 md:mb-14 md:text-lg">
        Industries we have worked across.
      </p>
    </div>
    <div aria-hidden="true" className="overflow-hidden border-y border-line py-5 md:py-6">
      <div className="marquee-track">
        <Group />
        <Group />
      </div>
    </div>
    <ul className="sr-only">
      {INDUSTRIES.map((name) => (
        <li key={name}>{name}</li>
      ))}
    </ul>
  </section>
);
